<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">채용안내</h3>
      </div>
      <div class="txt">
        <h4 class="fs-30">채용 절차</h4>
        <p class="pdt30 pdb50">
          <img :src="require('./../../assets/img/sub/04/0403_01.png')" />
        </p>

        <h4 class="fs-30 pdt50 pdb30">일정</h4>
        <p class="lh30 pdb50">수시 : 충원 필요 시 수시 공지(신입/경력)</p>

        <h4 class="fs-30 pdt50 pdb30">지원 방법</h4>
        <p class="lh30">
          동국제강 그룹 채용 페이지를 통한 온라인 지원
          <br />각종 채용정보 사이트를 통한 온라인 지원
        </p>
      </div>
    </div>
    <div class="item pdt50">
      <div class="tit">
        <h3 class="fNS-EB">채용공고</h3>
      </div>
      <div class="txt">
        <p class>
          <a
            href="https://dongkukgroup.saramin.co.kr/main/index"
            target="_blank"
          >
            <img :src="require('./../../assets/img/sub/04/0403_02.png')" />
          </a>
        </p>
        <p class="pdt15">상기 이미지 클릭시 채용사이트로 이동</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Recruitment.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub04/Recruitment.vue